export enum BooleanOperator {
    AND = 'AND',
    OR = 'OR'
}
